<template>
  <v-col cols="10" md="8" lg="6">
    <v-lazy v-model="inView" width="100%">
      <div class="elevation-2 rounded-xl pa-4 my-10">
        <v-text-field
          dir="auto"
          v-model="result.title"
          label="Titel"
          outlined
        ></v-text-field>
        <v-textarea
          dir="auto"
          v-model="result.description"
          label="Beskrivning"
          outlined
        ></v-textarea>
        <AddContent v-model="result.extracontent" />
        <ul>
          <li v-for="(option, i) in value.options" :key="i">
            <v-row>
              <v-col cols="8">
                <v-text-field
                  dir="auto"
                  label="text"
                  v-model="result.options[i].label"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-select
                  label="värde"
                  :items="options"
                  v-model="result.options[i].value"
                  outlined
                ></v-select>
              </v-col>
            </v-row>
          </li>
        </ul>
      </div>
    </v-lazy>
  </v-col>
</template>

<script>
import AddContent from "./AddContent.vue";
export default {
  name: "CreateQuestion",
  props: {
    value: Object
  },
  components: {
    AddContent
  },
  data() {
    return {
      inView: false,
      options: [
        { text: "Ja", value: "Ja" },
        { text: "Nej", value: "Nej" },
        { text: "Ja på lång sikt", value: "JaLång" }
      ]
    };
  },
  computed: {
    result: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    }
  }
};
</script>

<style scoped>
li {
  list-style-type: "-";
  padding-inline-start: 1ch;
}
</style>
